import { ClickProps } from "../../interfaces";

const Close = ({onClick}: ClickProps): JSX.Element => (
    <div onClick={onClick}>
        <svg 
            version="1.1" 
            id="Capa_1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" y="0px"
            width="612.006px" 
            height="612.006px" 
            viewBox="0 0 612.006 612.006" 
        >
            <g>
                <g>
                    <g>
                        <g>
                            <path d="M423.23,437.955c-3.769,0-7.53-1.438-10.41-4.311L178.371,199.177c-5.748-5.747-5.748-15.068,0-20.815
					c5.753-5.753,15.068-5.753,20.815,0l234.45,234.46c5.753,5.753,5.753,15.075,0,20.815
					C430.762,436.518,426.999,437.955,423.23,437.955z"/>
                            <path d="M188.781,437.955c-3.769,0-7.531-1.438-10.411-4.311c-5.748-5.747-5.748-15.069,0-20.816l234.449-234.466
					c5.753-5.753,15.068-5.753,20.815,0c5.753,5.747,5.753,15.068,0,20.815l-234.45,234.467
					C196.313,436.518,192.544,437.955,188.781,437.955z"/>
                        </g>
                        <path d="M306.038,612.006v-14.721l-0.023,14.721c-168.722,0-306-137.271-306.012-306C0.003,137.272,137.275,0,306.003,0
				c168.729,0,306,137.272,306,306.006C612.003,474.74,474.743,612.006,306.038,612.006z M306.003,29.442
				c-152.5,0-276.558,124.064-276.558,276.563c0.012,152.487,124.076,276.558,276.569,276.558h0.023
				c152.47,0,276.521-124.059,276.521-276.558C582.561,153.506,458.496,29.442,306.003,29.442z"/>
                    </g>
                </g>
            </g>
        </svg>
    </div>
);

export default Close;